// @ts-nocheck

import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { useIntl } from 'react-intl';
import { CustomThemeProvider, Prompt, usePortal } from 'sonata-react-components';

function ReportingCommentDeletionPrompt({ commentId, onClose }) {
  const intl = useIntl();

  const promptButtons = [
    {
      onClick: () => onClose(commentId),
      shape: 'squareRounded',
      text: intl.formatMessage({
        defaultMessage: 'Delete comment',
        id: 'reporting.commentSection.deletionPrompt.confirmButton'
      }),
      type: 'primary'
    }
  ];

  const targetBodyPrompt = usePortal('commentSection_deletionPrompt');

  return ReactDOM.createPortal(
    <CustomThemeProvider themeContrast="light">
      <Prompt
        buttons={promptButtons}
        closePrompt={onClose}
        description={intl.formatMessage({
          defaultMessage: 'If you do, the comment will be lost',
          id: 'reporting.commentSection.deletionPrompt.description'
        })}
        icon="fas fa-exclamation-triangle"
        id="commentSection_prompt"
        title={intl.formatMessage({
          defaultMessage: 'Are you sure you want to delete the comment?',
          id: 'reporting.commentSection.deletionPrompt.title'
        })}
      />
    </CustomThemeProvider>,
    targetBodyPrompt
  );
}

ReportingCommentDeletionPrompt.propTypes = {
  commentId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ReportingCommentDeletionPrompt;
